module.exports = __webpack_public_path__ + "static/media/forex_worldwide.42dc12df.png";